export const items = [
  {
    name: "Green Tea",
    image: require("../assets/green.jpg"),
    imageAlt: require("../assets/green2.jpg"),
    description: "Light and subtle",
    price: "445.50",
    id: 1,
  },
  {
    name: "Black Tea",
    image: require("../assets/black.jpg"),
    imageAlt: require("../assets/black2.jpg"),
    description: "Smooth and Bright",
    price: "5550.50",
    id: 2,
  },
  {
    name: "Matcha",
    image: require("../assets/matcha.jpg"),
    imageAlt: require("../assets/matcha2.jpg"),
    description: "Vibrant and Bold",
    price: "665.00",
    id: 3,
  },
  {
    name: "Pu-erh Tea",
    image: require("../assets/puer.jpg"),
    imageAlt: require("../assets/puer2.jpg"),
    description: "Rich and Fragrant",
    price: "455.50",
    id: 4,
  },
];
